/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
export const gridWithGap = {
  display: 'grid',
  gridGap: '1rem',
};
